import React, { useEffect, useState } from 'react';
import Input from '../../fields/Input';
import Button from '../../fields/Button';
import { GLOBAL_VARIABLES } from '../../../../utilites/variables';
import { useDispatch, useSelector } from 'react-redux';
import { HandleFormData } from '../../../../utilites';
import allActions from '../../../../Store/action';


const CorporateCSCorp = () => {
    const { CorporateCSCorpAnswers } = GLOBAL_VARIABLES;

    const dispatch=useDispatch()
	const [{ taxPayerForm, taxPayerFormData, formInformation }] = useSelector((state) => [state.taxForms]);
	const uploadFormData = HandleFormData({ parentIndex: 0, myIndex: 17 });

    const [specificQuestions, setSpecificQuestions] = useState([]);

    useEffect(() => {
        setSpecificQuestions(JSON.parse(JSON.stringify(CorporateCSCorpAnswers)));
    }, [CorporateCSCorpAnswers]);

    const handleInputChange = (index, value, data, valIdx) => {
        const filedKey = Object.keys(data).find(key => key !== 'placeholder' && key !== 'styleProp');
        const updatedQuestions = [...specificQuestions];
        updatedQuestions[index].values[valIdx][filedKey] = value;
        setSpecificQuestions(updatedQuestions);
    };

    useEffect(() => {
    	if (taxPayerForm?.data?.CorporateCSCorp) {
    		if (Object.keys(taxPayerForm?.data?.CorporateCSCorp).length === 0) return;
            const {
                specificQuestions
            } = taxPayerForm?.data?.CorporateCSCorp;

            setSpecificQuestions(specificQuestions)
    	}
    }, [taxPayerForm?.data?.CorporateCSCorp]);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission here
        let FormObj = {
              specificQuestions
          };
          let formData = taxPayerForm;
          taxPayerForm.data.CorporateCSCorp = FormObj;
          dispatch(allActions.taxForms.StoreFormData({ formData }));
          uploadFormData(formData);
    };

    const goBack = () => {
		// CHANGE FORM TO BACK
		let parentIndex = 0;
		let myIndex = 17;
		dispatch(allActions.taxForms.moveToBack({ parentIndex, myIndex, taxPayerFormData }));
	};


    return (
        <form className="w-100 mt-3" onSubmit={handleSubmit}>
            {/* <small className="ml-4 fw-bold">General Information</small>
            <hr className="m-0" /> */}
            <div className="mt-3 row justify-content-between px-3 custom-left-form">
                {specificQuestions.map((data, i) => {
                    return (<div key={i} className="col-md-12 mb-3">
                        <small className="ml-4 fw-bold">{data.question}</small>
                                <div className='row'>
                                    {data?.values?.map((data, index) => {
                                        return (
                                            <div className={`my-1 ${data.styleProp}`}>
                                                <Input
                                                    type="text"
                                                    value={specificQuestions[i].values[index][Object.keys(data).find(key => key !== 'placeholder' && key !== 'styleProp')]}
                                                    placeholder={data.placeholder}
                                                    fn={(value) => handleInputChange(i, value, data, index)}
                                                />
                                            </div>)
                                    })}
                                </div>  
                    </div>)
                })}
            </div>
            <div className="container-fluid content-row pb-4">
                <div className="d-flex align-items-center justify-content-center row">
                    <Button
                        mainClass="btn btn-info custon-button-text w-100 text-dark"
                        buttonText="Previous"
                        wrapperClass={'w-25 custon-button mt-4'}
                        type="button"
                        callback={()=>goBack()}
                    />
                    <Button
                        mainClass="btn btn-primary custon-button-text w-100"
                        buttonText="Next"
                        wrapperClass={'w-25 custon-button mt-4'}
                        type="submit"
                        disabled={!formInformation?.lead_id}
                    />
                </div>
            </div>
        </form>
    );
};

export default CorporateCSCorp;
